export const normalizeQuestionId = (id?: string | null): string => (id ?? '').toLowerCase();
